'use client'

import SessionProvider from '@/components/SessionProvider'

export default function LoginLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <SessionProvider>
      {children}
    </SessionProvider>
  )
} 